import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWindsurfNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M9.833 0C9.4 0 8.996.217 8.757.577L3.165 9h-1.79v1.25H3.38l8.033 3.19a7.316 7.316 0 01-.326.56H3v1.25h13V14h-3.47c.152-.293.322-.659.49-1.098.495-1.285.98-3.193.98-5.73C14 3.006 12.64 1.03 12.06.38a1.168 1.168 0 00-.878-.38zM6.768 10.25h5.704a12.93 12.93 0 01-.558 2.043zM12.709 6H8v1.25h4.75c-.003.627-.037 1.21-.094 1.75h-7.99l5.132-7.731a.042.042 0 01.035-.019h1.328c.119.138.304.38.508.75H11v1.25h1.202c.074.229.145.478.21.75H10v1.25h2.636c.03.238.055.488.073.75z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWindsurfNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWindsurfNormalXsmall;
